module.exports = __webpack_public_path__ + "static/media/personal_password.d5937ce6.svg";